import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi, CP_TOKEN_KEY, CP_REFRESH_KEY, CP_USER_KEY, CP_ID_KEY, limpiarSesionCliente } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem(CP_USER_KEY);
    const token = localStorage.getItem(CP_TOKEN_KEY);

    if (saved && token && token !== 'undefined' && token !== 'null') {
      try {
        setUser(JSON.parse(saved));
      } catch {
        limpiarSesionCliente();
      }
    } else {
      limpiarSesionCliente();
    }
    setLoading(false);

    // Cuando el refresh token falla, limpiar el estado de sesion
    // ProtectedRoute se encarga de redirigir a /login automaticamente
    const handleExpired = () => {
      setUser(null);
    };
    window.addEventListener('cp:session-expired', handleExpired);
    return () => window.removeEventListener('cp:session-expired', handleExpired);
  }, []);

  const login = async (username, password) => {
    const data = await authApi.login({ username, password });

    // El backend devuelve accessToken (camelCase) segun debug confirmado
    const token =
      data.access_token ||
      data.accessToken  ||
      data.token        ||
      data.jwt;

    const userData =
      data.cliente ||
      data.user    ||
      data.usuario ||
      data.perfil  ||
      {};

    if (!token) {
      throw new Error('El servidor no devolvio un token de acceso.');
    }

    // Guardar con prefijo cp_
    localStorage.setItem(CP_TOKEN_KEY, token);
    localStorage.setItem(CP_USER_KEY, JSON.stringify(userData));
    if (userData?.id) localStorage.setItem(CP_ID_KEY, userData.id);

    // Guardar refresh token si viene (backend puede enviar camelCase o snake_case)
    const refreshToken = data.refresh_token || data.refreshToken;
    if (refreshToken) {
      localStorage.setItem(CP_REFRESH_KEY, refreshToken);
    }

    setUser(userData);
    return data;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch { /* ignorar error de red */ }
    limpiarSesionCliente();
    setUser(null);
  };

  const updateUser = (newUser) => {
    const merged = { ...user, ...newUser };
    localStorage.setItem(CP_USER_KEY, JSON.stringify(merged));
    setUser(merged);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}